import { useEffect } from "react";
import { type UseFormReturn } from "react-hook-form";

import type { IRegion } from "@jti/magento";
import type { CheckoutShippingStepData } from "@jti/store/slices/standardCheckoutFormSlice";

import type { SHIPPING_FORM_FIELDS } from "../../constants";

type AddressKey =
  typeof SHIPPING_FORM_FIELDS.billingAddress | typeof SHIPPING_FORM_FIELDS.atHomeDeliveryShippingAddress;

export const useAddressRegionMapping = (
  formContext: UseFormReturn<CheckoutShippingStepData>,
  addressKey: AddressKey,
  regions: IRegion[] | undefined
) => {
  const address = formContext.watch(addressKey);
  const { setValue } = formContext;

  useEffect(() => {
    if (!address?.regionCode || !regions?.length) {
      return;
    }

    const currentRegion = address.region;
    const matchedRegion = regions.find((region) => region.code === address.regionCode);

    if (matchedRegion && currentRegion?.region_id !== matchedRegion.id) {
      setValue(`${addressKey}.region`, {
        region_id: matchedRegion.id,
        region_code: matchedRegion.code,
        region: matchedRegion.name,
      });
    }
  }, [address, regions, addressKey, setValue]);
};
